import { useState } from "react";
import { Star, Quote, ChevronLeft, ChevronRight, CheckCircle2 } from "lucide-react";
import { Button } from "@/components/ui/button";

interface Testimonial {
  name: string;
  country: string;
  countryFlag: string;
  investment: string;
  roi: string;
  quote: string;
  rating: number;
  investmentDate: string;
  verified: boolean;
}

export default function TestimonialsSection() {
  const [currentIndex, setCurrentIndex] = useState(0);

  const testimonials: Testimonial[] = [
    {
      name: "M. Kumar",
      country: "India",
      countryFlag: "🇮🇳",
      investment: "$440,000",
      roi: "11.2%",
      quote: "My Dubai real estate investment with Suite Global has been a game-changer. The 10% rental income in Dubai is real, and the tax-free property status is a huge bonus. I'm now considering another Dubai property for sale with them.",
      rating: 5,
      investmentDate: "Purchased 2021 (Dubai Marina)",
      verified: true
    },
    {
      name: "Zhang W.",
      country: "China",
      countryFlag: "🇨🇳",
      investment: "$440,000",
      roi: "12.3%",
      quote: "As someone who wanted to invest in Dubai from China, I found the process seamless. My high ROI Dubai apartment is generating excellent returns, making it the best rental yield in Dubai for me. This is a top-tier international property investment in Dubai.",
      rating: 5,
      investmentDate: "Purchased 2022 (Business Bay)",
      verified: true
    },
    {
      name: "Dmitri P.",
      country: "Russia",
      countryFlag: "🇷🇺",
      investment: "$250,000",
      roi: "10.9%",
      quote: "I was looking for a solid USD investment in Dubai, and Suite Global delivered. My Dubai apartment investment has seen significant appreciation, and the tax-free capital gains are a major plus. This is a great Dubai investment opportunity.",
      rating: 5,
      investmentDate: "Purchased 2020 (JVC)",
      verified: true
    },
    {
      name: "H. Al-****",
      country: "Saudi Arabia",
      countryFlag: "🇸🇦",
      investment: "$440,000",
      roi: "11.7%",
      quote: "The Dubai property payment plan made it easy for me to get started. Now, I'm enjoying a steady income from my Dubai residential investment. It's the perfect expat property in Dubai.",
      rating: 5,
      investmentDate: "Purchased 2021 (Downtown Dubai)",
      verified: true
    },
    {
      name: "Giuseppe R.",
      country: "Italy",
      countryFlag: "🇮🇹",
      investment: "$250,000",
      roi: "10.6%",
      quote: "This affordable Dubai property has exceeded all my expectations. The returns are fantastic, and the process of Dubai property investment for foreigners was surprisingly simple. I highly recommend it.",
      rating: 5,
      investmentDate: "Purchased 2021 (Arabian Ranches)",
      verified: true
    },
    {
      name: "Robert M.",
      country: "United States",
      countryFlag: "🇺🇸",
      investment: "$440,000",
      roi: "11.4%",
      quote: "As an American, I wanted a secure international property investment. My Dubai property has delivered tax-free returns and impressive appreciation. It's a fantastic way to diversify a portfolio.",
      rating: 5,
      investmentDate: "Purchased 2021 (Dubai Hills)",
      verified: true
    },
    {
      name: "Fatima H.",
      country: "Lebanon",
      countryFlag: "🇱🇧",
      investment: "$250,000",
      roi: "10.7%",
      quote: "This Dubai property investment has been a safe haven for my capital. The USD-based income and tax-free status provide peace of mind. It's a reliable way to grow wealth.",
      rating: 5,
      investmentDate: "Purchased 2020 (JVC)",
      verified: true
    },
    {
      name: "Klaus S.",
      country: "Germany",
      countryFlag: "🇩🇪",
      investment: "$440,000",
      roi: "11.8%",
      quote: "For anyone looking to invest in Dubai from Germany, this is the way to go. The returns are far better than what's available at home, and the Dubai property market is booming. A great opportunity.",
      rating: 5,
      investmentDate: "Purchased 2022 (Palm Jumeirah)",
      verified: true
    },
    {
      name: "Mehmet Y.",
      country: "Turkey",
      countryFlag: "🇹🇷",
      investment: "$250,000",
      roi: "10.8%",
      quote: "Investing in Dubai from Turkey was the best decision I made. My investment is safe from currency fluctuations, and the returns are excellent. I'm now planning my next Dubai real estate investment.",
      rating: 5,
      investmentDate: "Purchased 2021 (Dubai Sports City)",
      verified: true
    },
    {
      name: "Emma T.",
      country: "United Kingdom",
      countryFlag: "🇬🇧",
      investment: "$440,000",
      roi: "12.0%",
      quote: "For those looking to invest in Dubai from the UK, this is a golden opportunity. The tax-free environment and high returns are a world away from the UK market. A very smart move for any investor.",
      rating: 5,
      investmentDate: "Purchased 2021 (Emirates Living)",
      verified: true
    },
    {
      name: "Ali R.",
      country: "Pakistan",
      countryFlag: "🇵🇰",
      investment: "$440,000",
      roi: "12.1%",
      quote: "Getting a Dubai Golden Visa through property investment was a smooth process. The returns are great, and my family now has a second home. This is a life-changing Dubai investment opportunity.",
      rating: 5,
      investmentDate: "Purchased 2022 (Damac Hills)",
      verified: true
    },
    {
      name: "Jennifer L.",
      country: "Canada",
      countryFlag: "🇨🇦",
      investment: "$250,000",
      roi: "10.5%",
      quote: "If you want to invest in Dubai from Canada, this is a fantastic option. The returns are solid, and the management is professional. It's a hassle-free way to enter the Dubai property market.",
      rating: 5,
      investmentDate: "Purchased 2022 (Dubai Creek Harbour)",
      verified: true
    },
    {
      name: "Jean-Pierre D.",
      country: "France",
      countryFlag: "🇫🇷",
      investment: "$440,000",
      roi: "11.5%",
      quote: "Escaped French tax burden with Suite Global's Meydan project. Zero property tax, 11.5% returns, European-quality construction. Their track record makes Motor City investment a confident decision.",
      rating: 5,
      investmentDate: "Purchased 2022 (Meydan)",
      verified: true
    },
    {
      name: "Yuki S.",
      country: "Japan",
      countryFlag: "🇯🇵",
      investment: "$440,000",
      roi: "11.9%",
      quote: "Suite Global's Dubai Silicon Oasis project outperforms Tokyo yields by 8%. Consistent income delivered monthly, 18% appreciation. Their efficiency makes Motor City my next strategic investment.",
      rating: 5,
      investmentDate: "Purchased 2021 (Dubai Silicon Oasis)",
      verified: true
    },
    {
      name: "Carlos M.",
      country: "Spain",
      countryFlag: "🇪🇸",
      investment: "$250,000",
      roi: "10.6%",
      quote: "My Jumeirah Golf Estates investment through Suite Global provided stability during Spain's crisis. Consistent 10.8% returns, 14% growth. Motor City is my wealth protection strategy continuation.",
      rating: 5,
      investmentDate: "Purchased 2022 (Jumeirah Golf Estates)",
      verified: true
    },
    {
      name: "Omar K.",
      country: "Egypt",
      countryFlag: "🇪🇬",
      investment: "$250,000",
      roi: "10.7%",
      quote: "Suite Global's Town Square project protected my savings from Egyptian pound devaluation. Dollar income, 21% value increase, professional service. Motor City is my wealth preservation phase two.",
      rating: 5,
      investmentDate: "Purchased 2020 (Town Square)",
      verified: true
    },
    {
      name: "Lars N.",
      country: "Norway",
      countryFlag: "🇳🇴",
      investment: "$440,000",
      roi: "11.3%",
      quote: "Norwegian yields are 3-4%. My Dubai Marina investment with Suite Global delivers 11%+. Flexible payment, Golden Visa secured. Motor City offers same winning formula - I'm in.",
      rating: 5,
      investmentDate: "Purchased 2021 (Dubai Marina)",
      verified: true
    },
    {
      name: "Priya S.",
      country: "Singapore",
      countryFlag: "🇸🇬",
      investment: "$440,000",
      roi: "12.2%",
      quote: "Suite Global's Business Bay project mirrors Singapore's efficiency with better returns. 12% yield, top-tier management, 19% appreciation. Motor City is my portfolio expansion with proven partner.",
      rating: 5,
      investmentDate: "Purchased 2022 (Business Bay)",
      verified: true
    },
    {
      name: "André V.",
      country: "Netherlands",
      countryFlag: "🇳🇱",
      investment: "$250,000",
      roi: "10.8%",
      quote: "Dutch property market is overpriced with low yields. My Dubai Land investment through Suite Global delivers 10.8% with zero hassle. Their ongoing support makes Motor City an easy second investment.",
      rating: 5,
      investmentDate: "Purchased 2022 (Dubai Land)",
      verified: true
    },
    {
      name: "Hassan M.",
      country: "Morocco",
      countryFlag: "🇲🇦",
      investment: "$250,000",
      roi: "10.9%",
      quote: "Suite Global's Al Furjan project exceeded expectations - guaranteed income delivered, 16% appreciation. Proximity to Morocco perfect. Motor City is my logical next step with them.",
      rating: 5,
      investmentDate: "Purchased 2021 (Al Furjan)",
      verified: true
    },
    {
      name: "Olga K.",
      country: "Ukraine",
      countryFlag: "🇺🇦",
      investment: "$440,000",
      roi: "11.6%",
      quote: "Suite Global's Dubai Hills project secured my family's future. Stable returns, residency path, peace of mind. Their crisis-proof track record makes Motor City investment essential for us.",
      rating: 5,
      investmentDate: "Purchased 2022 (Dubai Hills)",
      verified: true
    },
    {
      name: "Marcus L.",
      country: "South Africa",
      countryFlag: "🇿🇦",
      investment: "$250,000",
      roi: "10.7%",
      quote: "My Arabian Ranches investment with Suite Global provides rand-hedge and 10.7% dollar returns. Straightforward process, stable framework. Motor City is my offshore diversification phase two.",
      rating: 5,
      investmentDate: "Purchased 2022 (Arabian Ranches)",
      verified: true
    },
    {
      name: "Sofia R.",
      country: "Greece",
      countryFlag: "🇬🇷",
      investment: "$250,000",
      roi: "10.6%",
      quote: "Post-crisis, Suite Global's JVC project provided security I needed. Tax-free 10.6% returns, guaranteed income, exceptional quality. Motor City is my confidence-driven expansion.",
      rating: 5,
      investmentDate: "Purchased 2021 (JVC)",
      verified: true
    },
    {
      name: "David K.",
      country: "Australia",
      countryFlag: "🇦🇺",
      investment: "$440,000",
      roi: "11.7%",
      quote: "Australian yields are 2-3%. My Dubai Marina property through Suite Global delivers 11.7%. Professional remote management, better value. Motor City is my smart capital reallocation.",
      rating: 5,
      investmentDate: "Purchased 2021 (Dubai Marina)",
      verified: true
    },
    {
      name: "Maria G.",
      country: "Brazil",
      countryFlag: "🇧🇷",
      investment: "$250,000",
      roi: "10.8%",
      quote: "Suite Global's Downtown Dubai investment hedged my real exposure. Stable USD returns, 17% appreciation, professional management. Motor City is my dollar-strategy continuation.",
      rating: 5,
      investmentDate: "Purchased 2021 (Downtown Dubai)",
      verified: true
    },
    {
      name: "Ahmed S.",
      country: "Jordan",
      countryFlag: "🇯🇴",
      investment: "$440,000",
      roi: "11.4%",
      quote: "My Damac Hills investment with Suite Global delivers 11.4% plus Golden Visa. Proximity perfect, returns excellent. Motor City is my family's next chapter with trusted partner.",
      rating: 5,
      investmentDate: "Purchased 2022 (Damac Hills)",
      verified: true
    },
    {
      name: "Petra H.",
      country: "Austria",
      countryFlag: "🇦🇹",
      investment: "$250,000",
      roi: "10.7%",
      quote: "Escaped Austrian restrictions with Suite Global's Emirates Living project. Zero tax, 10.7% returns, transparent process. Outstanding support makes Motor City obvious next move.",
      rating: 5,
      investmentDate: "Purchased 2022 (Emirates Living)",
      verified: true
    },
    {
      name: "Kim J.",
      country: "South Korea",
      countryFlag: "🇰🇷",
      investment: "$440,000",
      roi: "12.1%",
      quote: "Suite Global's Business Bay property outperforms Seoul yields by 7%. Quality rivals Gangnam, returns triple Korean market. Motor City is my portfolio optimization with proven winner.",
      rating: 5,
      investmentDate: "Purchased 2022 (Business Bay)",
      verified: true
    }
  ];

  // Randomly select 2-4 testimonials on component mount
  const [displayedTestimonials] = useState(() => {
    const shuffled = [...testimonials].sort(() => Math.random() - 0.5);
    const count = Math.floor(Math.random() * 3) + 2; // 2-4 reviews
    return shuffled.slice(0, count);
  });

  const nextTestimonial = () => {
    setCurrentIndex((prev) => (prev + 1) % displayedTestimonials.length);
  };

  const prevTestimonial = () => {
    setCurrentIndex((prev) => (prev - 1 + displayedTestimonials.length) % displayedTestimonials.length);
  };

  const currentTestimonial = displayedTestimonials[currentIndex];

  return (
    <section className="py-20 bg-gradient-to-br from-muted/30 to-background">
      <div className="container">
        <div className="max-w-6xl mx-auto">
          {/* Section Header */}
          <div className="text-center mb-16">
            <div className="inline-block px-4 py-2 bg-accent/10 text-accent-foreground rounded-full font-semibold text-sm mb-4">
              INVESTOR SUCCESS STORIES
            </div>
            <h2 className="text-4xl md:text-5xl font-bold mb-6 text-foreground">
              Join Hundreds of Satisfied Investors
            </h2>
            <p className="text-lg md:text-xl text-muted-foreground max-w-3xl mx-auto">
              Real investors, real results. See how our clients are building wealth and securing their financial future with Motor City Dubai.
            </p>
          </div>

          {/* Stats Bar */}
          <div className="grid grid-cols-2 md:grid-cols-4 gap-4 mb-16">
            <div className="bg-card border border-border rounded-lg p-6 text-center">
              <div className="text-3xl font-bold text-primary mb-2">500+</div>
              <div className="text-sm text-muted-foreground">Happy Investors</div>
            </div>
            <div className="bg-card border border-border rounded-lg p-6 text-center">
              <div className="text-3xl font-bold text-primary mb-2">98%</div>
              <div className="text-sm text-muted-foreground">Satisfaction Rate</div>
            </div>
            <div className="bg-card border border-border rounded-lg p-6 text-center">
              <div className="text-3xl font-bold text-primary mb-2">$120M+</div>
              <div className="text-sm text-muted-foreground">Total Investment</div>
            </div>
            <div className="bg-card border border-border rounded-lg p-6 text-center">
              <div className="text-3xl font-bold text-primary mb-2">11.2%</div>
              <div className="text-sm text-muted-foreground">Avg. ROI</div>
            </div>
          </div>

          {/* Main Testimonial Card */}
          <div className="relative">
            <div className="bg-card border border-border rounded-2xl p-8 md:p-12 shadow-xl">
              {/* Quote Icon */}
              <div className="absolute top-8 right-8 opacity-10">
                <Quote className="w-24 h-24 text-primary" />
              </div>

              <div className="relative z-10">
                {/* Rating */}
                <div className="flex items-center gap-1 mb-6">
                  {[...Array(currentTestimonial.rating)].map((_, i) => (
                    <Star key={i} className="w-6 h-6 fill-accent text-accent" />
                  ))}
                </div>

                {/* Quote */}
                <blockquote className="text-xl md:text-2xl text-card-foreground leading-relaxed mb-8 font-light">
                  "{currentTestimonial.quote}"
                </blockquote>

                {/* Investor Info */}
                <div className="flex flex-col md:flex-row items-start md:items-center justify-between gap-6 pt-6 border-t border-border">
                  <div>
                    <div className="flex items-center gap-2 mb-1">
                      <h4 className="text-lg font-bold text-card-foreground">
                        {currentTestimonial.name}
                      </h4>
                      {currentTestimonial.verified && (
                        <CheckCircle2 className="w-5 h-5 text-primary" />
                      )}
                    </div>
                    <div className="text-sm text-muted-foreground">
                      <span className="mr-2">{currentTestimonial.countryFlag}</span>
                      {currentTestimonial.country} • Invested {currentTestimonial.investmentDate}
                    </div>
                  </div>

                  <div className="flex gap-4">
                    <div className="bg-primary/10 rounded-lg px-4 py-3 text-center">
                      <div className="text-sm text-muted-foreground mb-1">Investment</div>
                      <div className="text-lg font-bold text-primary">{currentTestimonial.investment}</div>
                    </div>
                    <div className="bg-accent/10 rounded-lg px-4 py-3 text-center">
                      <div className="text-sm text-muted-foreground mb-1">Annual ROI</div>
                      <div className="text-lg font-bold text-accent-foreground">{currentTestimonial.roi}</div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            {/* Navigation Buttons */}
            <div className="flex items-center justify-center gap-4 mt-8">
              <Button
                variant="outline"
                size="icon"
                onClick={prevTestimonial}
                aria-label="Previous testimonial"
                className="rounded-full w-12 h-12"
              >
                <ChevronLeft className="w-5 h-5" />
              </Button>

              {/* Dots Indicator */}
              <div className="flex gap-2">
                {displayedTestimonials.map((_, index) => (
                  <button
                    key={index}
                    onClick={() => setCurrentIndex(index)}
                    aria-label={`Go to testimonial ${index + 1}`}
                    className={`p-2 rounded-full transition-all ${
                      index === currentIndex 
                        ? "" 
                        : ""
                    }`}
                  >
                    <span className={`block w-2 h-2 rounded-full transition-all ${
                      index === currentIndex 
                        ? "bg-primary w-8" 
                        : "bg-muted-foreground/30 hover:bg-muted-foreground/50"
                    }`} />
                  </button>
                ))}
              </div>

              <Button
                variant="outline"
                size="icon"
                onClick={nextTestimonial}
                aria-label="Next testimonial"
                className="rounded-full w-12 h-12"
              >
                <ChevronRight className="w-5 h-5" />
              </Button>
            </div>
          </div>

          {/* Trust Badges */}
          <div className="mt-16 flex flex-wrap items-center justify-center gap-8 text-muted-foreground text-sm">
            <div className="flex items-center gap-2">
              <CheckCircle2 className="w-5 h-5 text-primary" />
              <span>Verified Reviews</span>
            </div>
            <div className="flex items-center gap-2">
              <CheckCircle2 className="w-5 h-5 text-primary" />
              <span>Real Investor Results</span>
            </div>
            <div className="flex items-center gap-2">
              <CheckCircle2 className="w-5 h-5 text-primary" />
              <span>Proven Track Record</span>
            </div>
            <div className="flex items-center gap-2">
              <CheckCircle2 className="w-5 h-5 text-primary" />
              <span>Full Transparency</span>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
